export type PT = number & { __unit: 'pt' }
export type MM = number & { __unit: 'mm' }
export type PX = number & { __unit: 'px' }

const MM_TO_PT = 2.8346

export const unit = {
  mm(mmValue: number): MM {
    return mmValue as MM
  },
  pt(ptValue: number): PT {
    return ptValue as PT
  },
  toPt(mmValue: MM): PT {
    return (mmValue * MM_TO_PT) as PT
  },
  /**
   * Sharp and other image processing libraries require dimensions in pixels.
   * We use 300 DPI as a standard for high-quality printing.
   */
  toPx(mmValue: MM, dpi = 300): PX {
    return Math.round((mmValue * dpi) / 25.4) as PX
  },
}
